export const OrderStatusWCEnum = {
    0: 'Pendiente',
    1: 'Procesando',
    2: 'Esperando',
    3: 'Completado',
    4: 'Cancelado',
    5: 'Reembolsado',
    6: 'Fallido',
    7: 'Borrador'
};